export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
};

export type AdminAction = {
  __typename?: 'AdminAction';
  icon?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  path: Scalars['String']['output'];
  /** Analytics tracking action name */
  trackAction: Scalars['String']['output'];
};

/** Things that a user is allowed to do */
export type Allow = {
  __typename?: 'Allow';
  /** TC analytics */
  analytics: Scalars['Boolean']['output'];
  /** Moderate reader comments */
  moderateComments: Scalars['Boolean']['output'];
  /** Allows users to see new version of the header */
  newHeader: Scalars['Boolean']['output'];
};

export enum BadgeStyle {
  /** Interactive badge */
  Interactive = 'INTERACTIVE',
  /** Just in badge */
  JustIn = 'JUST_IN',
  /** Most popular badge */
  MostPopular = 'MOST_POPULAR',
  /** New badge */
  New = 'NEW',
  /** No badge */
  None = 'NONE'
}

/** A block represents a piece of content that can be placed on a page. */
export type Block = {
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  /** The block type. */
  type: BlockEnum;
};

export enum BlockEnum {
  /** Blockquote block type. */
  Blockquote = 'BLOCKQUOTE',
  /** Body block type. */
  Body = 'BODY',
  /** Call to action block type. */
  CallToAction = 'CALL_TO_ACTION',
  /** Content summary block type. */
  ContentSummary = 'CONTENT_SUMMARY',
  /** Custom URL block type. */
  CustomUrl = 'CUSTOM_URL',
  /** Events block type. */
  Events = 'EVENTS',
  /** Grid block type. */
  Grid = 'GRID',
  /** Heading block type. */
  Heading = 'HEADING',
  /** Heading with body block type. */
  HeadingWithBody = 'HEADING_WITH_BODY',
  /** Iframe block type. */
  Iframe = 'IFRAME',
  /** Image block type. */
  Image = 'IMAGE',
  /** Jobs board block type. */
  JobsBoard = 'JOBS_BOARD',
  /** Line break block type. */
  LineBreak = 'LINE_BREAK',
  /** Link inline block type. */
  Link = 'LINK',
  /** Unordered/ordered list block type. */
  List = 'LIST',
  /** List item block type. */
  ListItem = 'LIST_ITEM',
  /** Most read block type. */
  MostRead = 'MOST_READ',
  /** Paragraph block type. */
  Paragraph = 'PARAGRAPH',
  /** Partners block type. */
  Partners = 'PARTNERS',
  /** Podcasts block type. */
  Podcasts = 'PODCASTS',
  /** Podcast summary block type. */
  PodcastSummary = 'PODCAST_SUMMARY',
  /** A text block type. */
  Text = 'TEXT',
  /** Video block type. */
  Video = 'VIDEO'
}

export type BlockInput = {
  /** The props associated with the block. */
  props: Scalars['JSON']['input'];
  /** The block type. */
  type: BlockEnum;
};

export type BlockquoteBlock = Block & {
  __typename?: 'BlockquoteBlock';
  caption?: Maybe<Scalars['String']['output']>;
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  text: Scalars['String']['output'];
  /** The block type. */
  type: BlockEnum;
};

export type BodyBlock = Block & {
  __typename?: 'BodyBlock';
  blocks: Array<Block>;
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  /** The block type. */
  type: BlockEnum;
  variant?: Maybe<Scalars['String']['output']>;
};

export type CallToActionBlock = Block & {
  __typename?: 'CallToActionBlock';
  href: Scalars['String']['output'];
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  style: CallToActionStyle;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** The block type. */
  type: BlockEnum;
};

export enum CallToActionStyle {
  /** Default call to action style. */
  Default = 'DEFAULT',
  /** Donate call to action style. */
  Donate = 'DONATE',
  /** Newsletter call to action style. */
  Newsletter = 'NEWSLETTER'
}

export type Color = {
  __typename?: 'Color';
  blue: Scalars['Float']['output'];
  green: Scalars['Float']['output'];
  hex: Scalars['String']['output'];
  red: Scalars['Float']['output'];
};

export type Content = ContentSummary & {
  __typename?: 'Content';
  /** The byline of the content. */
  byline?: Maybe<Scalars['String']['output']>;
  /** Type of the content. */
  contentType?: Maybe<ContentTypeEnum>;
  /** An ISO8601 timestamp that represents when the content was published or last updated */
  date?: Maybe<Scalars['String']['output']>;
  /** The ID of the content. */
  id: Scalars['ID']['output'];
  /** The lead image of the content. */
  image?: Maybe<Image>;
  /** The region of the content. */
  region: Region;
  /** The state of the content. */
  state: Scalars['String']['output'];
  /** The title of the content. */
  title: Scalars['String']['output'];
  /** A URL that links to the content. */
  url: Scalars['String']['output'];
};

/** A content summary represents a summarised piece of content. */
export type ContentSummary = {
  /** The byline of the content. */
  byline?: Maybe<Scalars['String']['output']>;
  /** Type of the content. */
  contentType?: Maybe<ContentTypeEnum>;
  /** The ID of the content. */
  id: Scalars['ID']['output'];
  /** The lead image of the content. */
  image?: Maybe<Image>;
  /** The title of the content. */
  title: Scalars['String']['output'];
};

export type ContentSummaryBlock = Block & ContentSummary & {
  __typename?: 'ContentSummaryBlock';
  /** The byline of the content. */
  byline?: Maybe<Scalars['String']['output']>;
  /** Type of the content. */
  contentType?: Maybe<ContentTypeEnum>;
  /** The customised title of the content. */
  customTitle?: Maybe<Scalars['String']['output']>;
  /** Whether to hide the byline. */
  hideByline?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the content. */
  id: Scalars['ID']['output'];
  /** The lead image of the content. */
  image?: Maybe<Image>;
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  /** The custom tag label. */
  tagLabel?: Maybe<Scalars['String']['output']>;
  /** The tag for the content. */
  tagStyle?: Maybe<TagStyle>;
  /** The title of the content. */
  title: Scalars['String']['output'];
  /** The block type. */
  type: BlockEnum;
  /** A URL that links to the content. */
  url: Scalars['String']['output'];
};

export enum ContentTypeEnum {
  /** The analysis content type. */
  Analysis = 'analysis',
  /** The audio content type. */
  Audio = 'audio',
  /** The gallery content type. */
  Gallery = 'gallery',
  /** The news item content type. */
  NewsItem = 'news_item',
  /** The post content type. */
  Post = 'post',
  /** The research content type. */
  Research = 'research'
}

export type Crop = {
  __typename?: 'Crop';
  height: Scalars['Int']['output'];
  type: CropEnum;
  width: Scalars['Int']['output'];
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export enum CropEnum {
  /** Variable height crop. */
  Free = 'free',
  /** A 3:2 ratio  crop. */
  Landscape = 'landscape',
  /** A 2:1 ratio crop. */
  Pano = 'pano',
  /** A 1:1 ratio crop. */
  Square = 'square'
}

export type CustomUrlBlock = Block & {
  __typename?: 'CustomUrlBlock';
  /** The byline of the custom URL block. */
  byline?: Maybe<Scalars['String']['output']>;
  /** The URL that the link points to. */
  href: Scalars['String']['output'];
  /** The image asset of a custom URL block. */
  image?: Maybe<Image>;
  /** The alt text for the image. */
  imageAlt: Scalars['String']['output'];
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  /** The custom tag label. */
  tagLabel?: Maybe<Scalars['String']['output']>;
  /** The tag for the content. */
  tagStyle?: Maybe<TagStyle>;
  /** The title of the custom URL block. */
  title: Scalars['String']['output'];
  /** The block type. */
  type: BlockEnum;
};

export type Dimensions = {
  __typename?: 'Dimensions';
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

/** A document represents a collection of blocks and associated metadata. */
export type Document = {
  __typename?: 'Document';
  /** The blocks that contain the contents of the document. */
  blocks: Array<Block>;
  /** The optional metadata associated with the document. */
  meta?: Maybe<Scalars['JSON']['output']>;
};

export type DocumentInput = {
  /** The blocks that contain the contents of the document. */
  blocks: Array<BlockInput>;
  /** The optional metadata associated with the document. */
  meta?: InputMaybe<Scalars['JSON']['input']>;
};

export type DominantColors = {
  __typename?: 'DominantColors';
  muted?: Maybe<Color>;
  mutedDark?: Maybe<Color>;
  mutedLight?: Maybe<Color>;
  vibrant?: Maybe<Color>;
  vibrantDark?: Maybe<Color>;
  vibrantLight?: Maybe<Color>;
};

export type Donations = {
  __typename?: 'Donations';
  lastDonated: Scalars['String']['output'];
  lastDonationRecurring?: Maybe<Scalars['Boolean']['output']>;
  lastRegionDonatedTo?: Maybe<Scalars['String']['output']>;
  numDonations?: Maybe<Scalars['Int']['output']>;
  numDonationsThisYear?: Maybe<Scalars['Int']['output']>;
  totalAmount?: Maybe<Scalars['Int']['output']>;
  totalAmountThisYear?: Maybe<Scalars['Int']['output']>;
};

export type Emails = {
  __typename?: 'Emails';
  email: Scalars['String']['output'];
  newsletterSubscriptions: Array<NewsletterSubscriptions>;
  primary: Scalars['Boolean']['output'];
};

export type Event = {
  __typename?: 'Event';
  /** Additional info related to the event, course, or podcast. Often attribution. */
  byline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The URL for the image most associated with the event, course, or podcast */
  imageSrc?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The internal URL we use to collect data on before redirecting users to the destination */
  trackingUrl: Scalars['String']['output'];
};

export type EventsBlock = Block & {
  __typename?: 'EventsBlock';
  /** Promoted events of the page's region */
  events: Array<Event>;
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  /** The block type. */
  type: BlockEnum;
};

export type GridBlock = Block & {
  __typename?: 'GridBlock';
  blocks: Array<Block>;
  columns: Scalars['Int']['output'];
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  slotSizes: Array<GridSlotSize>;
  slotTypes: Array<GridSlot>;
  /** The block type. */
  type: BlockEnum;
};

export enum GridSlot {
  Editorial = 'EDITORIAL',
  Iframe = 'IFRAME',
  Podcast = 'PODCAST'
}

export enum GridSlotSize {
  Base = 'BASE',
  BaseWide = 'BASE_WIDE',
  DisappearingThumbnail = 'DISAPPEARING_THUMBNAIL',
  Lg = 'LG',
  NearFullByFour = 'NEAR_FULL_BY_FOUR',
  NearFullByThree = 'NEAR_FULL_BY_THREE',
  NearFullByTwo = 'NEAR_FULL_BY_TWO',
  Xl = 'XL',
  Xxl = 'XXL'
}

export type Group = {
  __typename?: 'Group';
  groupItems: Array<GroupItem>;
  /** The newsletter group name */
  name: Scalars['String']['output'];
};

export type GroupItem = {
  __typename?: 'GroupItem';
  /** The newsletter list long description (AKA, blurb) */
  description: Scalars['String']['output'];
  /** The newsletter list frequency */
  frequency: Scalars['String']['output'];
  /** The hero image URL of the newsletter list */
  heroImageUrl: Scalars['String']['output'];
  /** The newsletter list ID */
  id: Scalars['ID']['output'];
  /** The newsletter list name */
  name: Scalars['String']['output'];
  /** The newsletter list short description (AKA, pitch) */
  pitch: Scalars['String']['output'];
  /** The URL of the latest newsletter of a list */
  previewUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the newsletter list is promoted */
  promoted: Scalars['Boolean']['output'];
  /** The thumbnail image URL of the newsletter list */
  thumbnailImageUrl: Scalars['String']['output'];
};

export type HeadingBlock = Block & {
  __typename?: 'HeadingBlock';
  level?: Maybe<Scalars['Int']['output']>;
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  text: Scalars['String']['output'];
  /** The block type. */
  type: BlockEnum;
};

export type IframeBlock = Block & {
  __typename?: 'IframeBlock';
  height: Scalars['Int']['output'];
  infographicId: Scalars['Int']['output'];
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  src: Scalars['String']['output'];
  /** The block type. */
  type: BlockEnum;
};

export type Image = {
  __typename?: 'Image';
  alt: Scalars['String']['output'];
  crop?: Maybe<Crop>;
  /** User-defined crops for the image */
  crops: Array<Crop>;
  dimensions: Dimensions;
  id: Scalars['ID']['output'];
  /** Algorithmic extraction of dominant color values for the image */
  paletteData: PaletteData;
  /** Returns a placeholder color in hex or HSL format */
  placeholderColor: Scalars['String']['output'];
  src: Scalars['String']['output'];
};


export type ImageCropArgs = {
  aspectRatio?: InputMaybe<Scalars['String']['input']>;
};

export type ImageBlock = Block & {
  __typename?: 'ImageBlock';
  alt?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  src: Scalars['String']['output'];
  /** The block type. */
  type: BlockEnum;
};

export type Infographic = {
  __typename?: 'Infographic';
  /** An ISO8601 timestamp that represents when the infographic was created */
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  src: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Job = {
  __typename?: 'Job';
  /** Expiration date of the job listing */
  expirationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Location of the job listing */
  location?: Maybe<Scalars['String']['output']>;
  /** Logo URL of the job listing */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Title of the job listing */
  title?: Maybe<Scalars['String']['output']>;
  /** URL of the job listing */
  url?: Maybe<Scalars['String']['output']>;
};

export type JobsBoardBlock = Block & {
  __typename?: 'JobsBoardBlock';
  /** Job listing of a region */
  jobs: Array<Job>;
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  /** The block type. */
  type: BlockEnum;
};

export type Language = {
  __typename?: 'Language';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
  labelInOwnLanguage: Scalars['String']['output'];
};

export type LinkBlock = Block & {
  __typename?: 'LinkBlock';
  blocks: Array<Block>;
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  /** The block type. */
  type: BlockEnum;
  url: Scalars['String']['output'];
};

export type ListBlock = Block & {
  __typename?: 'ListBlock';
  blocks: Array<Block>;
  ordered: Scalars['Boolean']['output'];
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  /** The block type. */
  type: BlockEnum;
};

export type ListItemBlock = Block & {
  __typename?: 'ListItemBlock';
  blocks: Array<Block>;
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  /** The block type. */
  type: BlockEnum;
};

export type MostReadBlock = Block & {
  __typename?: 'MostReadBlock';
  /** The most read content for a page */
  contentSummaries: Array<Content>;
  /** Whether to filter region by commissioning region instead of content placement region */
  filterByCommissioningRegion: Scalars['Boolean']['output'];
  /** The language of content to filter for */
  language: Scalars['String']['output'];
  /** The section page of content to filter for */
  pageSlug: Scalars['String']['output'];
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  /** The region of content to filter for */
  regionCode: Scalars['String']['output'];
  /** The block type. */
  type: BlockEnum;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Creates a new PageBuilder page */
  createPage?: Maybe<PageCreatePayload>;
  /** Reverts a PageBuilder page to a previous version */
  revertPage?: Maybe<RevertPagePayload>;
};


export type MutationCreatePageArgs = {
  input: PageCreateInput;
};


export type MutationRevertPageArgs = {
  input: RevertPageInput;
};

/** An error that occurs as a result of a mutation */
export type MutationError = {
  __typename?: 'MutationError';
  /** A unique key for the error */
  key: Scalars['String']['output'];
  /** A description of the error */
  messages: Array<Scalars['String']['output']>;
};

export type NavItem = {
  __typename?: 'NavItem';
  path: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type NewsletterList = {
  __typename?: 'NewsletterList';
  /** The newsletter list frequency */
  frequency: Scalars['String']['output'];
  /** The newsletter list ID */
  id: Scalars['ID']['output'];
  /** The newsletter list name */
  name: Scalars['String']['output'];
  /** The newsletter list short description (AKA, pitch) */
  pitch: Scalars['String']['output'];
  /** The region of the newsletter list */
  region: Region;
};

export type NewsletterListPage = {
  __typename?: 'NewsletterListPage';
  cacheKey: Scalars['String']['output'];
  groups: Array<Group>;
};

export type NewsletterSubscriptions = {
  __typename?: 'NewsletterSubscriptions';
  newsletterList: NewsletterList;
  newsletterListId: Scalars['ID']['output'];
  subscribed: Scalars['Boolean']['output'];
};

export type Page = {
  __typename?: 'Page';
  author: PublicUser;
  cacheKey: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  doc: Document;
  id: Scalars['ID']['output'];
  pageType: PageTypeEnum;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  route: Route;
  schemaVersion: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of PageCreate */
export type PageCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  doc: DocumentInput;
  pageType: PageTypeEnum;
  routeId: Scalars['ID']['input'];
  schemaVersion: Scalars['Int']['input'];
};

/** Autogenerated return type of PageCreate. */
export type PageCreatePayload = {
  __typename?: 'PageCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  page?: Maybe<Page>;
  success: Scalars['Boolean']['output'];
};

export enum PageTypeEnum {
  /** Article */
  Article = 'article',
  /** Home page */
  HomePage = 'home_page',
  /** Internal */
  Internal = 'internal',
  /** Resource */
  Resource = 'resource',
  /** Section */
  Section = 'section',
  /** Topic */
  Topic = 'topic'
}

export type PaletteData = {
  __typename?: 'PaletteData';
  averageLuminance: Scalars['Float']['output'];
  dominantColors: DominantColors;
};

export type ParagraphBlock = Block & {
  __typename?: 'ParagraphBlock';
  blocks: Array<Block>;
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  /** The block type. */
  type: BlockEnum;
};

export type Partner = {
  __typename?: 'Partner';
  /** URL of the partner's logo, without query strings */
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  /** The type of institution ie founding or strategic */
  type: Scalars['String']['output'];
};

export type PartnersBlock = Block & {
  __typename?: 'PartnersBlock';
  /** Helper text that appears near list of partners */
  explainer: Scalars['String']['output'];
  /** Text that describes link to partners page */
  partnerLinkDescription: Scalars['String']['output'];
  /** Partners of the page's region */
  partners: Array<Partner>;
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  /** The block type. */
  type: BlockEnum;
};

export type PodcastSummaryBlock = Block & {
  __typename?: 'PodcastSummaryBlock';
  /** The average length of the podcast. */
  averageLengthMinutes?: Maybe<Scalars['Int']['output']>;
  /** The badge for the content. */
  badge: BadgeStyle;
  /** The description of the podcast. */
  description: Scalars['String']['output'];
  /** The URL that the link points to. */
  href: Scalars['String']['output'];
  /** The image asset of a podcast. */
  image?: Maybe<Image>;
  /** The alt text for the image. */
  imageAlt: Scalars['String']['output'];
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  /** The title of the podcast. */
  title: Scalars['String']['output'];
  /** The block type. */
  type: BlockEnum;
};

export type PodcastsBlock = Block & {
  __typename?: 'PodcastsBlock';
  blocks: Array<Block>;
  /** The URL that the link points to. */
  linkToAllPodcasts?: Maybe<Scalars['String']['output']>;
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  /** The block type. */
  type: BlockEnum;
};

/** Represents a user in TC without exposing any sensitive details */
export type PublicUser = {
  __typename?: 'PublicUser';
  avatar: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Only the active/public regions */
  activeRegions: Array<Region>;
  /** The admin actions a viewer can take for a given path */
  adminActions: Array<AdminAction>;
  /** Most recent published version of a PageBuilder page */
  currentPage?: Maybe<Page>;
  /** Most recent editable version of a PageBuilder page */
  draftPage?: Maybe<Page>;
  /** Returns upcoming promoted events, courses and podcasts in chronological order */
  events: Array<Event>;
  /** Returns the page history for a given region and slug */
  history?: Maybe<Array<Page>>;
  /** Allows querying for a particular infographic by id */
  infographic?: Maybe<Infographic>;
  /** Allows searching for infographics by title */
  infographicSearch?: Maybe<Array<Infographic>>;
  /** Jobs from jobboard.io */
  jobs?: Maybe<Array<Job>>;
  /** The languages available in the system */
  languages: Array<Language>;
  /** The most read content for a page */
  mostRead: Array<Content>;
  /** The navigation items for a given region */
  navItems: Array<NavItem>;
  /** Newsletters subscription page of a region */
  newslettersPage?: Maybe<NewsletterListPage>;
  /** Partners of a given region */
  partners?: Maybe<Array<Partner>>;
  /** PageBuilder routes */
  routes?: Maybe<Array<Route>>;
  /** Returns most relevant content for the given search query */
  search?: Maybe<Array<Content>>;
  /** All unplaced content for a page */
  unplacedContent?: Maybe<Array<Content>>;
  /** The person, logged in or not, currently viewing any given resource. */
  viewer: Viewer;
};


export type QueryAdminActionsArgs = {
  path: Scalars['String']['input'];
};


export type QueryCurrentPageArgs = {
  regionCode: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryDraftPageArgs = {
  regionCode: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  regionCode: Scalars['String']['input'];
};


export type QueryHistoryArgs = {
  regionCode: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryInfographicArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInfographicSearchArgs = {
  query: Scalars['String']['input'];
};


export type QueryMostReadArgs = {
  filterByCommissioningRegion?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  pageSlug?: InputMaybe<Scalars['String']['input']>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNavItemsArgs = {
  regionCode: Scalars['String']['input'];
};


export type QueryNewslettersPageArgs = {
  regionCode: Scalars['String']['input'];
};


export type QueryPartnersArgs = {
  pageSlug?: InputMaybe<Scalars['String']['input']>;
  regionCode: Scalars['String']['input'];
};


export type QueryRoutesArgs = {
  regionCode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchArgs = {
  query: Scalars['String']['input'];
  regionCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUnplacedContentArgs = {
  regionCode: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type Region = {
  __typename?: 'Region';
  code: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  nameInRegionLanguage: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of RevertPage */
export type RevertPageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pageId: Scalars['ID']['input'];
  routeId: Scalars['ID']['input'];
};

/** Autogenerated return type of RevertPage. */
export type RevertPagePayload = {
  __typename?: 'RevertPagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  page?: Maybe<Page>;
  success: Scalars['Boolean']['output'];
};

export enum RoleEnum {
  /** Someone who contributes content. Usually belonging to an institution. */
  Author = 'Author',
  /** Staff member. */
  Editor = 'Editor',
  /** A regular user. May or may not be signed in. */
  Reader = 'Reader'
}

export type Route = {
  __typename?: 'Route';
  collectionCacheKey: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  region: Region;
  resourceCacheKey: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum TagStyle {
  /** Audio tag */
  Audio = 'AUDIO',
  /** Custom tag */
  Custom = 'CUSTOM',
  /** No tag */
  None = 'NONE',
  /** Video tag */
  Video = 'VIDEO'
}

export type TextBlock = Block & {
  __typename?: 'TextBlock';
  format?: Maybe<Array<Scalars['String']['output']>>;
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  text: Scalars['String']['output'];
  /** The block type. */
  type: BlockEnum;
};

export type User = {
  __typename?: 'User';
  /** Things the user is allowed to do */
  allow: Allow;
  avatar: Scalars['String']['output'];
  commentNotificationCount: Scalars['Int']['output'];
  donations?: Maybe<Donations>;
  emails: Array<Emails>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  newsFeedCount: Scalars['Int']['output'];
};

export type VideoBlock = Block & {
  __typename?: 'VideoBlock';
  caption?: Maybe<Scalars['String']['output']>;
  /** The props associated with the block. */
  props: Scalars['JSON']['output'];
  src: Scalars['String']['output'];
  /** The block type. */
  type: BlockEnum;
};

export type Viewer = {
  __typename?: 'Viewer';
  role: RoleEnum;
  user?: Maybe<User>;
};

export type ContentSummaryFieldsFragment = { __typename?: 'Content', id: string, state: string, date?: string | null, title: string, byline?: string | null, contentType?: ContentTypeEnum | null, region: { __typename?: 'Region', code: string }, image?: { __typename?: 'Image', src: string, alt: string, placeholderColor: string, crop?: { __typename?: 'Crop', type: CropEnum, height: number, width: number, x: number, y: number } | null, crops: Array<{ __typename?: 'Crop', type: CropEnum, height: number, width: number, x: number, y: number }> } | null };

export type SearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  regionCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchQuery = { __typename?: 'Query', search?: Array<{ __typename?: 'Content', id: string, state: string, date?: string | null, title: string, byline?: string | null, contentType?: ContentTypeEnum | null, region: { __typename?: 'Region', code: string }, image?: { __typename?: 'Image', src: string, alt: string, placeholderColor: string, crop?: { __typename?: 'Crop', type: CropEnum, height: number, width: number, x: number, y: number } | null, crops: Array<{ __typename?: 'Crop', type: CropEnum, height: number, width: number, x: number, y: number }> } | null }> | null };

export type UnplacedContentQueryVariables = Exact<{
  regionCode: Scalars['String']['input'];
  slug: Scalars['String']['input'];
}>;


export type UnplacedContentQuery = { __typename?: 'Query', unplacedContent?: Array<{ __typename?: 'Content', id: string, state: string, date?: string | null, title: string, byline?: string | null, contentType?: ContentTypeEnum | null, region: { __typename?: 'Region', code: string }, image?: { __typename?: 'Image', src: string, alt: string, placeholderColor: string, crop?: { __typename?: 'Crop', type: CropEnum, height: number, width: number, x: number, y: number } | null, crops: Array<{ __typename?: 'Crop', type: CropEnum, height: number, width: number, x: number, y: number }> } | null }> | null };

export type CommonDataQueryQueryVariables = Exact<{
  regionCode: Scalars['String']['input'];
}>;


export type CommonDataQueryQuery = { __typename?: 'Query', navItems: Array<{ __typename?: 'NavItem', title: string, position: number, path: string }>, activeRegions: Array<{ __typename?: 'Region', code: string, nameInRegionLanguage: string }> };

export type EventsQueryVariables = Exact<{
  regionCode: Scalars['String']['input'];
}>;


export type EventsQuery = { __typename?: 'Query', events: Array<{ __typename?: 'Event', id: string, name: string, trackingUrl: string, byline: string, imageSrc?: string | null }> };

export type InfographicQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InfographicQuery = { __typename?: 'Query', infographic?: { __typename?: 'Infographic', id: string, src: string, title: string } | null };

export type InfographicSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type InfographicSearchQuery = { __typename?: 'Query', infographicSearch?: Array<{ __typename?: 'Infographic', id: string, title: string, createdAt?: string | null }> | null };

export type JobsBoardQueryVariables = Exact<{ [key: string]: never; }>;


export type JobsBoardQuery = { __typename?: 'Query', jobs?: Array<{ __typename?: 'Job', url?: string | null, title?: string | null, logoUrl?: string | null, expirationDate?: any | null, location?: string | null }> | null };

export type MostReadQueryVariables = Exact<{
  regionCode?: InputMaybe<Scalars['String']['input']>;
  filterByCommissioningRegion?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  pageSlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type MostReadQuery = { __typename?: 'Query', mostRead: Array<{ __typename?: 'Content', id: string, title: string, byline?: string | null, url: string, image?: { __typename?: 'Image', src: string, placeholderColor: string, crops: Array<{ __typename?: 'Crop', type: CropEnum, width: number, height: number, x: number, y: number }> } | null }> };

export type MostReadInspectorQueryVariables = Exact<{
  regionCode: Scalars['String']['input'];
}>;


export type MostReadInspectorQuery = { __typename?: 'Query', languages: Array<{ __typename?: 'Language', code: string, label: string }>, routes?: Array<{ __typename?: 'Route', id: string, slug: string, region: { __typename?: 'Region', code: string } }> | null, navItems: Array<{ __typename?: 'NavItem', path: string, title: string }> };

export type PartnersQueryVariables = Exact<{
  regionCode: Scalars['String']['input'];
  pageSlug: Scalars['String']['input'];
}>;


export type PartnersQuery = { __typename?: 'Query', partners?: Array<{ __typename?: 'Partner', name: string, path: string, logoUrl: string, type: string }> | null };

export type PageHistoryQueryVariables = Exact<{
  regionCode: Scalars['String']['input'];
  pageSlug: Scalars['String']['input'];
}>;


export type PageHistoryQuery = { __typename?: 'Query', history?: Array<{ __typename?: 'Page', id: string, createdAt: any, author: { __typename?: 'PublicUser', name: string }, route: { __typename?: 'Route', id: string } }> | null };

export type CreatePageMutationVariables = Exact<{
  input: PageCreateInput;
}>;


export type CreatePageMutation = { __typename?: 'Mutation', createPage?: { __typename?: 'PageCreatePayload', success: boolean, errors: Array<{ __typename?: 'MutationError', key: string, messages: Array<string> }> } | null };

export type RevertPageMutationVariables = Exact<{
  input: RevertPageInput;
}>;


export type RevertPageMutation = { __typename?: 'Mutation', revertPage?: { __typename?: 'RevertPagePayload', success: boolean, errors: Array<{ __typename?: 'MutationError', key: string, messages: Array<string> }> } | null };

export type LexicalPageQueryVariables = Exact<{
  regionCode: Scalars['String']['input'];
  pageSlug: Scalars['String']['input'];
}>;


export type LexicalPageQuery = { __typename?: 'Query', draftPage?: { __typename?: 'Page', id: string, schemaVersion: number, updatedAt: any, pageType: PageTypeEnum, doc: { __typename?: 'Document', meta?: any | null, blocks: Array<{ __typename?: 'BlockquoteBlock', type: BlockEnum, props: any } | { __typename?: 'BodyBlock', type: BlockEnum, props: any } | { __typename?: 'CallToActionBlock', href: string, title: string, text: string, style: CallToActionStyle, type: BlockEnum, props: any } | { __typename?: 'ContentSummaryBlock', type: BlockEnum, props: any } | { __typename?: 'CustomUrlBlock', type: BlockEnum, props: any } | { __typename?: 'EventsBlock', type: BlockEnum, props: any } | { __typename?: 'GridBlock', slotSizes: Array<GridSlotSize>, slotTypes: Array<GridSlot>, type: BlockEnum, props: any, blocks: Array<{ __typename?: 'BlockquoteBlock', type: BlockEnum } | { __typename?: 'BodyBlock', type: BlockEnum } | { __typename?: 'CallToActionBlock', type: BlockEnum } | { __typename?: 'ContentSummaryBlock', type: BlockEnum, id: string, url: string, title: string, customTitle?: string | null, byline?: string | null, contentType?: ContentTypeEnum | null, hideByline?: boolean | null, tagStyle?: TagStyle | null, tagLabel?: string | null, image?: { __typename?: 'Image', src: string, alt: string, placeholderColor: string, paletteData: { __typename?: 'PaletteData', averageLuminance: number }, crops: Array<{ __typename?: 'Crop', type: CropEnum, width: number, height: number, x: number, y: number }> } | null } | { __typename?: 'CustomUrlBlock', type: BlockEnum, props: any, title: string, href: string, byline?: string | null, tagLabel?: string | null, tagStyle?: TagStyle | null, imageAlt: string, image?: { __typename?: 'Image', id: string, src: string, alt: string, placeholderColor: string, paletteData: { __typename?: 'PaletteData', averageLuminance: number }, crops: Array<{ __typename?: 'Crop', type: CropEnum, width: number, height: number, x: number, y: number }> } | null } | { __typename?: 'EventsBlock', type: BlockEnum } | { __typename?: 'GridBlock', type: BlockEnum } | { __typename?: 'HeadingBlock', type: BlockEnum } | { __typename?: 'IframeBlock', type: BlockEnum } | { __typename?: 'ImageBlock', type: BlockEnum } | { __typename?: 'JobsBoardBlock', type: BlockEnum } | { __typename?: 'LinkBlock', type: BlockEnum } | { __typename?: 'ListBlock', type: BlockEnum } | { __typename?: 'ListItemBlock', type: BlockEnum } | { __typename?: 'MostReadBlock', type: BlockEnum } | { __typename?: 'ParagraphBlock', type: BlockEnum } | { __typename?: 'PartnersBlock', type: BlockEnum } | { __typename?: 'PodcastSummaryBlock', type: BlockEnum } | { __typename?: 'PodcastsBlock', type: BlockEnum } | { __typename?: 'TextBlock', type: BlockEnum } | { __typename?: 'VideoBlock', type: BlockEnum }> } | { __typename?: 'HeadingBlock', type: BlockEnum, props: any } | { __typename?: 'IframeBlock', type: BlockEnum, props: any } | { __typename?: 'ImageBlock', type: BlockEnum, props: any } | { __typename?: 'JobsBoardBlock', type: BlockEnum, props: any, jobs: Array<{ __typename?: 'Job', expirationDate?: any | null, location?: string | null, logoUrl?: string | null, title?: string | null, url?: string | null }> } | { __typename?: 'LinkBlock', type: BlockEnum, props: any } | { __typename?: 'ListBlock', type: BlockEnum, props: any } | { __typename?: 'ListItemBlock', type: BlockEnum, props: any } | { __typename?: 'MostReadBlock', type: BlockEnum, regionCode: string, filterByCommissioningRegion: boolean, language: string, pageSlug: string, props: any, contentSummaries: Array<{ __typename?: 'Content', id: string, title: string, byline?: string | null, url: string, image?: { __typename?: 'Image', src: string, placeholderColor: string, paletteData: { __typename?: 'PaletteData', averageLuminance: number }, crops: Array<{ __typename?: 'Crop', type: CropEnum, width: number, height: number, x: number, y: number }> } | null }> } | { __typename?: 'ParagraphBlock', type: BlockEnum, props: any } | { __typename?: 'PartnersBlock', type: BlockEnum, explainer: string, partnerLinkDescription: string, props: any, partners: Array<{ __typename?: 'Partner', name: string, logoUrl: string, path: string, type: string }> } | { __typename?: 'PodcastSummaryBlock', type: BlockEnum, props: any } | { __typename?: 'PodcastsBlock', linkToAllPodcasts?: string | null, type: BlockEnum, props: any, blocks: Array<{ __typename?: 'BlockquoteBlock', type: BlockEnum } | { __typename?: 'BodyBlock', type: BlockEnum } | { __typename?: 'CallToActionBlock', type: BlockEnum } | { __typename?: 'ContentSummaryBlock', type: BlockEnum } | { __typename?: 'CustomUrlBlock', type: BlockEnum } | { __typename?: 'EventsBlock', type: BlockEnum } | { __typename?: 'GridBlock', type: BlockEnum } | { __typename?: 'HeadingBlock', type: BlockEnum } | { __typename?: 'IframeBlock', type: BlockEnum } | { __typename?: 'ImageBlock', type: BlockEnum } | { __typename?: 'JobsBoardBlock', type: BlockEnum } | { __typename?: 'LinkBlock', type: BlockEnum } | { __typename?: 'ListBlock', type: BlockEnum } | { __typename?: 'ListItemBlock', type: BlockEnum } | { __typename?: 'MostReadBlock', type: BlockEnum } | { __typename?: 'ParagraphBlock', type: BlockEnum } | { __typename?: 'PartnersBlock', type: BlockEnum } | { __typename?: 'PodcastSummaryBlock', title: string, href: string, description: string, imageAlt: string, badge: BadgeStyle, averageLengthMinutes?: number | null, type: BlockEnum, image?: { __typename?: 'Image', id: string, src: string, alt: string, placeholderColor: string, paletteData: { __typename?: 'PaletteData', averageLuminance: number }, crops: Array<{ __typename?: 'Crop', type: CropEnum, width: number, height: number, x: number, y: number }> } | null } | { __typename?: 'PodcastsBlock', type: BlockEnum } | { __typename?: 'TextBlock', type: BlockEnum } | { __typename?: 'VideoBlock', type: BlockEnum }> } | { __typename?: 'TextBlock', type: BlockEnum, props: any } | { __typename?: 'VideoBlock', type: BlockEnum, props: any }> }, route: { __typename?: 'Route', id: string, slug: string, region: { __typename?: 'Region', code: string } } } | null };

export type NewslettersPageQueryVariables = Exact<{
  regionCode: Scalars['String']['input'];
}>;


export type NewslettersPageQuery = { __typename?: 'Query', newslettersPage?: { __typename?: 'NewsletterListPage', cacheKey: string, groups: Array<{ __typename?: 'Group', name: string, groupItems: Array<{ __typename?: 'GroupItem', id: string, name: string, promoted: boolean, frequency: string, description: string, pitch: string, previewUrl?: string | null, heroImageUrl: string, thumbnailImageUrl: string }> }> } | null };

export type ViewPageQueryVariables = Exact<{
  regionCode: Scalars['String']['input'];
  pageSlug: Scalars['String']['input'];
}>;


export type ViewPageQuery = { __typename?: 'Query', currentPage?: { __typename?: 'Page', cacheKey: string, pageType: PageTypeEnum, doc: { __typename?: 'Document', meta?: any | null, blocks: Array<{ __typename?: 'BlockquoteBlock', type: BlockEnum, props: any } | { __typename?: 'BodyBlock', type: BlockEnum, props: any } | { __typename?: 'CallToActionBlock', href: string, title: string, text: string, style: CallToActionStyle, type: BlockEnum, props: any } | { __typename?: 'ContentSummaryBlock', type: BlockEnum, props: any } | { __typename?: 'CustomUrlBlock', type: BlockEnum, props: any } | { __typename?: 'EventsBlock', type: BlockEnum, props: any, events: Array<{ __typename?: 'Event', id: string, name: string, byline: string, imageSrc?: string | null, trackingUrl: string }> } | { __typename?: 'GridBlock', slotSizes: Array<GridSlotSize>, slotTypes: Array<GridSlot>, type: BlockEnum, props: any, blocks: Array<{ __typename?: 'BlockquoteBlock', type: BlockEnum } | { __typename?: 'BodyBlock', type: BlockEnum } | { __typename?: 'CallToActionBlock', type: BlockEnum } | { __typename?: 'ContentSummaryBlock', type: BlockEnum, id: string, url: string, tagStyle?: TagStyle | null, tagLabel?: string | null, title: string, customTitle?: string | null, byline?: string | null, contentType?: ContentTypeEnum | null, hideByline?: boolean | null, image?: { __typename?: 'Image', src: string, alt: string, placeholderColor: string, paletteData: { __typename?: 'PaletteData', averageLuminance: number }, crops: Array<{ __typename?: 'Crop', type: CropEnum, width: number, height: number, x: number, y: number }> } | null } | { __typename?: 'CustomUrlBlock', type: BlockEnum, props: any, title: string, href: string, byline?: string | null, tagLabel?: string | null, tagStyle?: TagStyle | null, imageAlt: string, image?: { __typename?: 'Image', id: string, src: string, alt: string, placeholderColor: string, paletteData: { __typename?: 'PaletteData', averageLuminance: number }, crops: Array<{ __typename?: 'Crop', type: CropEnum, width: number, height: number, x: number, y: number }> } | null } | { __typename?: 'EventsBlock', type: BlockEnum } | { __typename?: 'GridBlock', type: BlockEnum } | { __typename?: 'HeadingBlock', type: BlockEnum } | { __typename?: 'IframeBlock', type: BlockEnum } | { __typename?: 'ImageBlock', type: BlockEnum } | { __typename?: 'JobsBoardBlock', type: BlockEnum } | { __typename?: 'LinkBlock', type: BlockEnum } | { __typename?: 'ListBlock', type: BlockEnum } | { __typename?: 'ListItemBlock', type: BlockEnum } | { __typename?: 'MostReadBlock', type: BlockEnum } | { __typename?: 'ParagraphBlock', type: BlockEnum } | { __typename?: 'PartnersBlock', type: BlockEnum } | { __typename?: 'PodcastSummaryBlock', type: BlockEnum } | { __typename?: 'PodcastsBlock', type: BlockEnum } | { __typename?: 'TextBlock', type: BlockEnum } | { __typename?: 'VideoBlock', type: BlockEnum }> } | { __typename?: 'HeadingBlock', type: BlockEnum, props: any } | { __typename?: 'IframeBlock', type: BlockEnum, props: any } | { __typename?: 'ImageBlock', type: BlockEnum, props: any } | { __typename?: 'JobsBoardBlock', type: BlockEnum, props: any, jobs: Array<{ __typename?: 'Job', expirationDate?: any | null, location?: string | null, logoUrl?: string | null, title?: string | null, url?: string | null }> } | { __typename?: 'LinkBlock', type: BlockEnum, props: any } | { __typename?: 'ListBlock', type: BlockEnum, props: any } | { __typename?: 'ListItemBlock', type: BlockEnum, props: any } | { __typename?: 'MostReadBlock', type: BlockEnum, props: any, contentSummaries: Array<{ __typename?: 'Content', id: string, title: string, byline?: string | null, url: string, image?: { __typename?: 'Image', src: string, placeholderColor: string, paletteData: { __typename?: 'PaletteData', averageLuminance: number }, crops: Array<{ __typename?: 'Crop', type: CropEnum, width: number, height: number, x: number, y: number }> } | null }> } | { __typename?: 'ParagraphBlock', type: BlockEnum, props: any } | { __typename?: 'PartnersBlock', type: BlockEnum, explainer: string, partnerLinkDescription: string, props: any, partners: Array<{ __typename?: 'Partner', name: string, logoUrl: string, path: string, type: string }> } | { __typename?: 'PodcastSummaryBlock', type: BlockEnum, props: any } | { __typename?: 'PodcastsBlock', linkToAllPodcasts?: string | null, type: BlockEnum, props: any, blocks: Array<{ __typename?: 'BlockquoteBlock', type: BlockEnum } | { __typename?: 'BodyBlock', type: BlockEnum } | { __typename?: 'CallToActionBlock', type: BlockEnum } | { __typename?: 'ContentSummaryBlock', type: BlockEnum } | { __typename?: 'CustomUrlBlock', type: BlockEnum } | { __typename?: 'EventsBlock', type: BlockEnum } | { __typename?: 'GridBlock', type: BlockEnum } | { __typename?: 'HeadingBlock', type: BlockEnum } | { __typename?: 'IframeBlock', type: BlockEnum } | { __typename?: 'ImageBlock', type: BlockEnum } | { __typename?: 'JobsBoardBlock', type: BlockEnum } | { __typename?: 'LinkBlock', type: BlockEnum } | { __typename?: 'ListBlock', type: BlockEnum } | { __typename?: 'ListItemBlock', type: BlockEnum } | { __typename?: 'MostReadBlock', type: BlockEnum } | { __typename?: 'ParagraphBlock', type: BlockEnum } | { __typename?: 'PartnersBlock', type: BlockEnum } | { __typename?: 'PodcastSummaryBlock', title: string, href: string, description: string, imageAlt: string, badge: BadgeStyle, averageLengthMinutes?: number | null, type: BlockEnum, image?: { __typename?: 'Image', id: string, src: string, alt: string, placeholderColor: string, paletteData: { __typename?: 'PaletteData', averageLuminance: number }, crops: Array<{ __typename?: 'Crop', type: CropEnum, width: number, height: number, x: number, y: number }> } | null } | { __typename?: 'PodcastsBlock', type: BlockEnum } | { __typename?: 'TextBlock', type: BlockEnum } | { __typename?: 'VideoBlock', type: BlockEnum }> } | { __typename?: 'TextBlock', type: BlockEnum, props: any } | { __typename?: 'VideoBlock', type: BlockEnum, props: any }> } } | null };
